import React, {useState, useEffect, useRef} from 'react';
import { Link, useParams } from 'react-router-dom';
import { faCog, faTv, faPencil } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { API_URL } from '../global/components/Constants';
import { parsePhotoUtil } from '../utils/photoUtils';
import { topicThemes } from '../utils/topicUtils';
import { getCategories } from '../utils/api-services/global';
import EditTopicLink from './components/EditTopicLink';
import Tags from '../global/components/Tags';


function TopicSettings() {

    const [topic, setTopic] = useState(null);
    const [settings, setSettings] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedItem, setSelectedItem] = useState("");
    const [value, setValue] = useState("");
    const [photo, setPhoto] = useState({Data:"", Selected:false});
    const [tagList, setTagList] = useState([]);
    const [modal, setModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [frmError, setFrmError] = useState("");
    const [loading, setLoading] = useState(false);
    const [posting, setPosting] = useState(false);

    const { code } = useParams();
    const photoElem = useRef();

    const width = 500;
    const height = 500;

    useEffect(()=>{
        loadTopic();
        loadCategories();
    }, []);

    function loadTopic(){
        setLoading(true);

        axios({
            method: 'get',
            url: API_URL + `topic/topic_by_slug?slug=${code}`,
        }).then((respose)=>{
            const obj = respose.data;
            if(obj.Success){
                setLoading(false);
                setTopic(obj.Data);
                parseSettingsData(obj.Data);
            }
        });
    }

    const loadCategories = async () => {
        const data = await getCategories();
        setCategories(data);
    }

    function parseSettingsData(obj){
        const tags = (obj.Tags != "")? JSON.parse(obj.Tags): "";
        const data = [
            {Code: "Title", Title: "Title", Display: obj.Title, Value: obj.Title},
            {Code: "Category", Title: "Category", Display: obj.CategoryName, Value: obj.Category},
            {Code: "Description", Title: "Description", Display: obj.Description, Value: obj.Description},
            {Code: "Theme", Title: "Theme", Display: obj.Theme, Value: obj.Theme},
            {Code: "Photo", Title: "Photo", Display: obj.Photo, Value: obj.Photo},
            {Code: "Tags", Title: "Tags", Display: "", Value: tags}, 
        ];
        setSettings(data);
    }

    function editPreset(obj){
        showModal();
        setModalTitle(obj.Title);
        setSelectedItem(obj.Code);

        if(obj.Code == "Photo"){
            if(obj.Value != ""){
                setPhoto({Data:obj.Value, Selected:false});
            }
        }
        else if(obj.Code == "Tags"){
            setTagList(obj.Value);
        }
        else{
            setValue(obj.Value);
        }
    }

    const showModal = ()=>{
        clearForm();
        setModal(true);
    }

    const selectPhoto = ()=>{
        photoElem.current.click();
    }
    
    const handlePhotoChange = (event) => {
        let files = event.target.files;
        const params = {
            file: files[0],
            width: width, 
            height: height,
            setPhoto: setPhoto, 
            setMessage: setFrmError
        }
        parsePhotoUtil(params);
    }

    function saveForm(){
        if(selectedItem == "Photo"){
            if(photo.Data == ""){
                setFrmError("Please select photo");
                return false;
            }
            postForm(selectedItem, photo.Data);
        }
        else if(selectedItem == "Tags"){
            if(tagList.length == 0){
                setFrmError("Please add tags");
                return false;
            }
            postForm(selectedItem, JSON.stringify(tagList));
        }
        else{
            if(value == ""){
                setFrmError("Please enter value");
                return false;
            }
            postForm(selectedItem, value);
        }
    }

    function postForm(column, value){

        setPosting(true);

        const formData = new FormData();
        formData.append('id', topic?.Id);
        formData.append('column', column);
        formData.append('value', value);

        axios({
            method: "post",
            url: API_URL + "topic/update_topic_column",
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
            processData: false,
            contentType: false,
            mimeType: "multipart/form-data",
            withCredentials: true
        })
        .then(function (response) {
            setPosting(false)
            const obj = response.data;
            if(obj.Success){
                loadTopic();
                closeModal();
            }
        })
        .catch(function (response) {
            setPosting(false)
        });
    }

    const closeModal = ()=>{
        setModal(false);
    }

    function clearForm(){
        setValue("");
        setPhoto({Data:"", Selected:false});
        setTagList([]);
        setFrmError("");
    }

    const styles = {
        page:{
            background: '#fff',
            minHeight: 700,
            paddingTop: 50,
            paddingBottom: 100
        },
        heading:{
            display: 'flex'
        },
        title:{
            color: '#999',
            marginBottom: 30,
            marginRight: 50,
            fontSize: 18
        },
        link:{
            color: '#363636',
            marginRight: 30,
            fontSize: 14,
            fontWeight: 500,
            textDecoration: 'none',
            marginLeft: 'auto'
        },
        item:{
            paddingTop: 15,
            paddingBottom: 15,
            borderBottom: '1px solid #ccc'
        },
        itemTitle:{
            color: '#191919',
            fontSize: 14
        },
        itemValue: {
            fontSize: 13
        },
        itemEditBtn:{
            color: '#0767ce',
            fontSize: 14,
            textDecoration: 'none',
        },
        fileInput: {
            display: 'none'
        },
        photo:{
            preview:{
                width: 300,
                borderRadius: 5
            },
            previewImg:{
                width: 300,
                borderRadius: 5
            },
            imgDisplay:{
                width: 300,
                borderRadius: 5
            }
        },
        selectBtnWrap: {
            marginBottom: 10,
        },
        selectBtn: {
            textDecoration: 'none',
            fontSize: 16,
        },
        info: {
            fontSize: 13,
        },
        frmError:{
            color: '#990000',
            fontSize: 16
        },
        tags:{
            wrap:{
                display: 'flex',
                flexWrap: 'wrap',
                paddingTop: 10,
                paddingBottom: 10,
            },
            item:{
                marginRight: 10,
                marginBottom: 30,
                padding: '10px 20px',
                boxShadow: '0 0 3px 3px #efefef',
                borderRadius: 30
            }
        }
    }

    function settingsItem(obj){
        return (
            <div style={styles.item}>
                <div className='row'>
                    <div className='col-md-10'>
                        <h4 style={styles.itemTitle}>{obj.Title}</h4>
                        <div style={styles.itemValue}>{settingsItemDisplay(obj.Code, obj.Display)}</div>
                    </div>
                    <div className='col-md-2'>
                        <Link onClick={()=>editPreset(obj)} style={styles.itemEditBtn}>Edit</Link>
                    </div>
                </div>
            </div>
        )
    }

    function settingsItemDisplay(code, value){
        if(code == "Theme"){
            const colors = value.split("-");
            const bgColor = colors[0];
            const txtColor = colors[1];

            const styles = {
                preview: {
                    background: bgColor,
                    color: txtColor,
                    maxWidth: 300,
                    padding: '30px 30px',
                    borderRadius: 5,
                    fontSize: 18,
                    fontWeight: 500,
                    border: '1px solid #dfdfdf'
                }
            }

            return (
                <div style = {styles.preview}>
                    {topic.Title}
                </div>
            )
            
        }
        else if(code == "Photo"){
            if(value != ""){
                return <img src = {`${API_URL}/uploads/topic/${value}`} style={styles.photo.imgDisplay} />
            }
        }
        else if(code == "Tags"){
            return(
                <div style={styles.tags.wrap}>
                    {value.length > 0 && value.map(itm=>(
                        <div style={styles.tags.item}>{itm.Name}</div>
                    ))}
                </div>
            )
        }
        else{
            return value;
        }
    }

    const titleForm = (
        <div className="form-group">
            <input type="text" value={value} onChange={e => setValue(e.target.value)} className="form-control" placeholder="Enter value" />
        </div>
    )

    const categoryForm = (
        <div className="form-group">
            <select value={value} onChange={e => setValue(e.target.value)} className="form-control">
                <option key={0} value={""}>- Select -</option>
                {categories.map(itm=>(
                    <option key={itm.Id} value={itm.Slug}>{itm.Name}</option>
                ))}
            </select>
        </div>
    )

    const descForm = (
        <div className="form-group">
            <textarea value={value} onChange={e => setValue(e.target.value)} className="form-control" placeholder="Enter value"></textarea>
        </div>
    )

    const themeForm = (
        <div className='form-group'>
            <select value={value} onChange={e => setValue(e.target.value)} style={styles.input} className="form-control">
                {topicThemes.map(itm=>(
                    <option key={itm.Id} value={itm.Value}>{itm.Name}</option>
                ))}
            </select>
        </div>
    )

    const photoForm = (
        <div>

            {(photo.Data != "") &&
                <div style={styles.photo.preview}>
                    <img 
                        src = {photo.Selected? photo.Data: `${API_URL}/uploads/topic/${photo.Data}`} 
                        style={styles.photo.previewImg} 
                    />
                </div>
            }

            <div style = {styles.selectBtnWrap}>
                <Link onClick={selectPhoto} style = {styles.selectBtn}>Select Photo</Link>
            </div>
            <div style={styles.info}>{`Photo dimension should be ${width} x ${height} pixels or more`}</div>
            <input type="file" ref={photoElem} onChange={handlePhotoChange} style = {styles.fileInput} />
        </div>
    )

    const tagsForm = (
        <Tags params={{tagList: tagList, setTagList: setTagList}} />
    )
    
    return (
        <section style={styles.page}>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-2'></div>
                    <div className='col-md-10'>

                        <div style = {styles.heading}>
                            <h4 style={styles.title}>Settings</h4>
                            <div style={styles.link}>
                                <EditTopicLink code={topic?.Slug} entry = "settings" />
                            </div>
                        </div>

                        <hr />

                        {settings.length > 0 &&
                            <div>
                                {settings.map(itm=>(
                                    <div key={itm.Code}>{settingsItem(itm)}</div>
                                ))}
                            </div>
                        }
                    </div>
                </div>
            </div>

            <Modal show={modal} onHide={closeModal} backdrop="static" keyboard={false}>
                <Modal.Header>
                    <Modal.Title style={{fontSize:15}}>{modalTitle}</Modal.Title>
                    <button type="button" onClick={closeModal} className="close">&times;</button>
                </Modal.Header>
                <Modal.Body>  
                   
                    {selectedItem == "Title" && titleForm}
                    {selectedItem == "Category" && categoryForm}
                    {selectedItem == "Description" && descForm}
                    {selectedItem == "Theme" && themeForm}
                    {selectedItem == "Photo" && photoForm}
                    {selectedItem == "Tags" && tagsForm}

                    {frmError != "" && 
                        <div className="form-group" style={styles.frmError}>{frmError}</div>
                    }
                   
                    <hr />

                    <div className="form-group">
                        <Link onClick={()=>saveForm()} className='btn btn-primary'>{posting? "POSTING ...": "SAVE"}</Link>
                    </div>

                </Modal.Body> 
            </Modal>

        </section>
    )
    
}

export default TopicSettings;